/* lp-gallery — <lp-gallery>: swipe is native scroll-snap; settling on a slide updates the dots; dots and
   wrap-around prev/next scroll the track (echo-locked so intermediate slides don't flicker the state).
   setImages(urls, alt) rebuilds the slides + dots, used when a card swaps product (lp-product-duo tabs). */
(function () {
  'use strict';
  if (window.customElements.get('lp-gallery')) return;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  class LpGallery extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true; this._index = 0; this._lockUntil = 0;
      var self = this, settle = 0;
      this.track = this.querySelector('[data-lp-gallery-track]');
      this.track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () { if (Date.now() < self._lockUntil) return; var i = self.nearest(); if (i !== self._index) self.setActive(i); }, 80);
      }, { passive: true });
      this.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-lp-gallery-dot]'))) { e.preventDefault(); e.stopPropagation(); self.go(Number(t.dataset.lpGalleryDot)); }
        else if (e.target.closest('[data-lp-gallery-prev]')) { e.preventDefault(); e.stopPropagation(); self.go((self._index - 1 + self.slides().length) % self.slides().length); }
        else if (e.target.closest('[data-lp-gallery-next]')) { e.preventDefault(); e.stopPropagation(); self.go((self._index + 1) % self.slides().length); }
      });
    }
    slides() { return Array.prototype.slice.call(this.querySelectorAll('[data-lp-gallery-slide]')); }
    dots() { return Array.prototype.slice.call(this.querySelectorAll('[data-lp-gallery-dot]')); }
    nearest() {
      var s = this.slides(), centre = this.track.scrollLeft + this.track.clientWidth / 2, best = 0, bestD = Infinity;
      s.forEach(function (el, i) { var d = Math.abs(el.offsetLeft + el.clientWidth / 2 - centre); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    go(i) {
      var el = this.slides()[i]; if (!el) return;
      this.setActive(i); this._lockUntil = Date.now() + 700;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: el.offsetLeft + el.clientWidth / 2 - this.track.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    setActive(i) { this._index = i; this.dots().forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }
    /* rebuild for a new image set (card product swap); controls follow data-dots / data-arrows */
    setImages(urls, alt) {
      var self = this; urls = (urls || []).filter(Boolean);
      this.track.innerHTML = urls.map(function (u, i) { return '<img class="lp-gallery__img" data-lp-gallery-slide="' + i + '" src="' + esc(u) + '" alt="' + esc(alt || self.dataset.alt || '') + '" width="900" height="900" loading="lazy" draggable="false">'; }).join('');
      Array.prototype.forEach.call(this.querySelectorAll('[data-lp-gallery-prev],[data-lp-gallery-next],[data-lp-gallery-dots]'), function (el) { el.remove(); });
      if (urls.length > 1) {
        if (this.hasAttribute('data-arrows')) this.insertAdjacentHTML('beforeend', '<button type="button" class="lp-gallery__nav lp-gallery__nav--prev" data-lp-gallery-prev aria-label="Previous image">' + (this._prevIcon || '') + '</button><button type="button" class="lp-gallery__nav lp-gallery__nav--next" data-lp-gallery-next aria-label="Next image">' + (this._nextIcon || '') + '</button>');
        if (this.hasAttribute('data-dots')) this.insertAdjacentHTML('beforeend', '<div class="lp-gallery__dots" data-lp-gallery-dots>' + urls.map(function (u, i) { return '<button type="button" class="lp-gallery__dot' + (i === 0 ? ' is-active' : '') + '" data-lp-gallery-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>'; }).join('') + '</div>');
      }
      this._index = 0; this.track.scrollTo({ left: 0, behavior: 'auto' });
    }
    /* remember the server-rendered icon markup so a rebuilt gallery keeps the same glyphs */
    cacheIcons() { var p = this.querySelector('[data-lp-gallery-prev]'), n = this.querySelector('[data-lp-gallery-next]'); if (p) this._prevIcon = p.innerHTML; if (n) this._nextIcon = n.innerHTML; }
  }
  window.customElements.define('lp-gallery', LpGallery);
})();
